import "rxjs/add/operator/toPromise";
import "rxjs/Observable";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/map";
import "rxjs/add/operator/delay";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppComponent } from "./components/app.component";
import { ComponentLogin } from "./components/login/component.login";
import { LoginSectorComponent } from "./components/login-sector/login-sector.component";
import { DataService } from "./services/data.service";
import { AuthService } from "./services/auth.service";
import { NavMenuComponent } from "./components/nav-menu/nav-menu.component";
import { HomeComponent } from "./components/home/home.component";
import { AuthGuard } from "./auth/auth-guard";
import { PatientSearchComponent } from "./components/patient-search/patient-search.component";
import { PatientService } from "./services/patient.service";
import { PatientBottonSheetComponent } from "./components/patient-botton-sheet/patient-botton-sheet.component";
import { ReservationPatientComponent } from "./components/reservation/reservation-patient/reservation-patient.component";
import { ReservationPracticeComponent } from "./components/reservation/reservation-practice/reservation-practice.component";
import { EntityService } from "./services/entity.service";
import { LoginWizardService } from "./services/wizard/login/login.wizard.service";
import { ReservationRegularWizardService } from "./services/wizard/reservation/reservation.wizard.service";
import { ReservationOrderComponent } from "./components/reservation/reservation-order/reservation-order.component";
import { PracticeService } from "./services/practice.service";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";
import { ValorizationService } from "./services/valorization/valorization.service";
import { ReservationPriceComponent } from "./components/reservation/reservation-price/reservation-price.component";
import { HotkeyModule } from "angular2-hotkeys";
import { ReservationCalendarComponent } from "./components/reservation/reservation-calendar/reservation-calendar.component";
import { ReservationService } from "./services/reservation.service";
import { ReservationQuestionComponent } from "./components/reservation/reservation-question/reservation-question.component";
import { QuestionComponent } from "./components/question/question.component";
import { AutofocusDirective } from "./directives/autofocus.directive";
import { ReservationReminderComponent } from "./components/reservation/reservation-reminder/reservation-reminder.component";
import { ReservationPatientRequiredComponent } from "./components/reservation/reservation-patient-required/reservation-patient-required.component";
import { ToastrModule } from "ngx-toastr";
import { NotificationToastService } from "./services/notification-toast.service";
import { DialogCancelMedicalAppointmentComponent } from "./components/dialogs/medical-appointment-cancel/dialog-medical-appointment-cancel.component";
import { DialogConfirmtComponent } from "./components/dialogs/confirm/dialog-confirm.component";
import { ConfirmDialogService } from "./services/confirm-dialog.service";
import { ReservationWizardComponent } from "./components/reservation/reservation-wizard/reservation-wizard.component";
import { ReservationSearchComponent } from "./components/reservation/reservation-search/reservation-search.component";
import { ReservationFilterComponent } from "./components/reservation/reservation-filter/reservation-filter.component";
import {
  AppDateAdapter,
  APP_DATE_FORMATS,
} from "./infrastructure/date-adapter";
import { DeviceDetectorModule } from "ngx-device-detector";
import { AngularResizedEventModule } from "angular-resize-event";
import { ServiceService } from "./services/service.service";
import { FilterService } from "./services/filter.service";
import { PhysicianService } from "./services/physician.service";
import { EquipmentService } from "./services/equipment.service";
import { MedicalAppointmenObservationDialogComponent } from "./components/dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { AdmissionService } from "./services/admission.service";
import { FilterRecordService } from "./services/filter-record.service";
import { ReminderComponent } from "./components/reminder/reminder.component";
import { PatientViewDialogComponent } from "./components/dialogs/patient-view/patient-view-dialog.component";
import { MenuService } from "./services/menu.service";
import { ReservationInconsistentComponent } from "./components/reservation/reservation-inconsistent/reservation-inconsistent.component";
import { ReservationInconsistentFilterComponent } from "./components/reservation/reservation-inconsistent-filter/reservation-inconsistent-filter.component";
import { ChangeEquipmentPhysicianDialogComponent } from "./components/dialogs/change-equipment-physician/change-equipment-physician-dialog.component";
import { OtherMedicalAppointmenDialogComponent } from "./components/dialogs/other-medical-appointment/other-medical-appointment-dialog.component";
import { AdmissionReceptionSearchComponent } from "./components/admission/admision-reception-search/admission-reception-search.component";
import { AdmissionReceptionFilterComponent } from "./components/admission/admission-reception-filter/admission-reception-filter.component";
import { RequestInterceptor } from "./interceptors/request.interceptor";
import { AdmissionReceptionWizardComponent } from "./components/admission/admission-reception-wizard/admission-reception-wizard.component";
import { AdmissionPatientComponent } from "./components/admission/admission-patient/admission-patient.component";
import { AdmissionValorizationComponent } from "./components/admission/admission-valorization/admission-valorization.component";
import { AdmissionMedicalOrderComponent } from "./components/admission/admission-medical-order/admission-medical-order.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { CellContainerControlComponent } from "./components/controls/resizable-column/cell-container-control.compoent";
import { AdmissionOperationComponent } from "./components/admission/admission-operation/admission-operation.component";
import { MedicalOrderOperationControlComponent } from "./components/controls/medical-order-operation/medical-order-operation-control.component";
import { AdmissionMedicalOrderScannComponent } from "./components/admission/admission-medical-order-scann/admission-medical-order-scann.component";
import { QRCodeService } from "./services/qr-code.service";
import { QRCodeModule } from "angularx-qrcode";
import { MedicalOrderScannDialogComponent } from "./components/dialogs/medical-order-scann/medical-order-scann-dialog.component";
import { MedicalOrderService } from "./services/medical-order.service";
import { MedicalOrderScannZoomDialogComponent } from "./components/dialogs/medical-order-scann-zoom/medical-order-scann-zoom-dialog.component";
import { MedicalServiceFilterComponent } from "./components/medical-service/medical-service-filter/medical-service-filter.component";
import { MedicalServiceService } from "./services/medical-service.service";
import { MedicalServiceSearchComponent } from "./components/medical-service/medical-service-search/medical-service-search.component";
import { MedicalOrderScannComponent } from "./components/medical-order-scann/medical-order-scann.component";
import { OtherAdmissionMedicalAppointmenDialogComponent } from "./components/dialogs/other-admission-medical-appointment/other-admission-medical-appointment-dialog.component";
import { PhysicianReplacementDialogComponent } from "./components/dialogs/physician-replacement/physician-replacement-dialog.component";
import { EquipmentReplacementDialogComponent } from "./components/dialogs/equipment-replacement/equipment-replacement-dialog.component";
import { MedicalServiceWizardComponent } from "./components/medical-service/medical-service-wizard/medical-service-wizard.component";
import { MedicalServicePatientComponent } from "./components/medical-service/medical-service-patient/medical-service-patient.component";
import { MedicalServiceWizardService } from "./services/wizard/medical-service/medical-service-wizard";
import { MedicalServiceOperationComponent } from "./components/medical-service/medical-service-operation/medical-service-operation.component";
import { ClinicHistoryControlComponent } from "./components/controls/clinic-history/clinic-history-control.component";
import { MedicalServiceClinicHistoryComponent } from "./components/medical-service/medical-service-clinic-history/medical-service-clinic-history.component";
import { MedicalServiceCareComponent } from "./components/medical-service/medical-service-care/medical-service-care.component";
import { StudyReportService } from "./services/study-report/study-report.service";
import { StudyReportFilterComponent } from "./components/study-report/study-report-filter/study-report-filter.component";
import { StudyReportSearchComponent } from "./components/study-report/study-report-search/study-report-search.component";
import { StudyReportPatientComponent } from "./components/study-report/study-report-patient/study-report-patient.component";
import { StydyReportWizardComponent } from "./components/study-report/study-report-wizard/study-report-wizard.component";
import { StudyReportClinicHistoryComponent } from "./components/study-report/study-report-clinic-history/study-report-clinic-history.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { StudyReportOperationComponent } from "./components/study-report/study-report-operation/study-report-operation.component";
import { ReportService } from "./services/report.service";
import { Base64ToBlobService } from "./services/base64-to-blob.service";
import { PdfService } from "./services/pdf.service";
import { StudyReportEditControlComponent } from "./components/controls/study-report/study-report-edit/study-report-edit-control.component";
import { StudyReportPhysicianSignatureDialogComponent } from "./components/dialogs/study-report-physician-signature/study-report-physician-signature-dialog.component";
import { StudyReportTemplateDialogComponent } from "./components/dialogs/study-report-template/study-report-template-dialog.component";
import { StudyReportViewerDialogComponent } from "./components/dialogs/study-report-viewer/study-report-viewer-dialog.component";
import { StudyReportReverserReasonDialogComponent } from "./components/dialogs/study-report-reverser-reason/study-report-reverser-reason-dialog.component";
import { LogisticsService } from "./services/logistics.service";
import { SendOrderLogisticsFilterComponent } from "./components/logistics/order-logistics/send-order-logistics-filter/send-order-logistics-filter.component";
import { SendOrderLogisticsSearchComponent } from "./components/logistics/order-logistics/send-order-logistics-search/send-order-logistics-search.component";
import { SendIndividualOrderLogisticsComponent } from "./components/logistics/order-logistics/send-individual-order-logistics/send-individual-order-logistics.component";
import { SendIndividualStudyReportLogisticsComponent } from "./components/logistics/study-report-logistics/send-individual-study-report-logistics/send-individual-study-report-logistics.component";
import { CashDeskService } from "./services/cash-desk.service";
import { PendingCashDeskFilterComponent } from "./components/cash-desk/pending-cash-desk/pending-cash-desk-filter/pending-cash-desk-filter.component";
import { PendingCashDeskSearchComponent } from "./components/cash-desk/pending-cash-desk/pending-cash-desk-search/pending-cash-desk-search.component";
import { InvoiceCashDeskControlComponent } from "./components/controls/invoice-cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit-control.component";
import { InvoicePatientCashDeskEditComponent } from "./components/cash-desk/invoice-patient-cash-desk-edit/invoice-patient-cash-desk-edit.component";
import { InvoiceCashDeskEditComponent } from "./components/cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit.component";
import { InvoiceManualCashDeskEditComponent } from "./components/cash-desk/invoice-manual-cash-desk-edit/invoice-manual-cash-desk-edit.component";
import { InvoicePointService } from "./services/invoice-cash-desk/invoice-point.service";
import { ClientService } from "./services/client.service";
import { InvoiceCashDeskViewComponent } from "./components/cash-desk/invoice-cash-desk-view/invoice-cash-desk-view.component";
import { AdmissionInvoiceCashDeskComponent } from "./components/admission/admission-invoice-cash-desk/admission-invoice-cash-desk.component";
import { InvoicePatientCashDeskService } from "./services/invoice-cash-desk/invoice-patient-cash-desk.service";
import { MadeCashDeskFilterComponent } from "./components/cash-desk/made-cash-desk/made-cash-desk-filter/made-cash-desk-filter.component";
import { MadeCashDeskSearchComponent } from "./components/cash-desk/made-cash-desk/made-cash-desk-search/made-cash-desk-search.component";
import { InvoicePatientCreditNoteCashDeskEditComponent } from "./components/cash-desk/invoice-patient-credit-note-cash-desk-edit/invoice-patient-credit-note-cash-desk-edit.component";
import { InvoicePatientCashDeskViewComponent } from "./components/cash-desk/invoice-patient-cash-desk-view/invoice-patient-cash-desk-view.component";
import { CashDeskOpenFilterComponent } from "./components/cash-desk/cash-desk-open/cash-desk-open-filter/cash-desk-open-filter.component";
import { CashDeskOpenSearchComponent } from "./components/cash-desk/cash-desk-open/cash-desk-open-search/cash-desk-open-search.component";
import { CashDeskOpenEditComponent } from "./components/cash-desk/cash-desk-open/cash-desk-open-edit/cash-desk-open-edit.component";
import { CashDeskManualFilterComponent } from "./components/cash-desk/cash-desk-manual/cash-desk-manual-filter/cash-desk-manual-filter.component";
import { CashDeskManualSearchComponent } from "./components/cash-desk/cash-desk-manual/cash-desk-manual-search/cash-desk-manual-search.component";
import { InvoiceManualCashDeskViewComponent } from "./components/cash-desk/invoice-manual-cash-desk-view/invoice-manual-cash-desk-view.component";
import { InvoiceManualCreditNoteCashDeskEditComponent } from "./components/cash-desk/invoice-manual-credit-note-cash-desk-edit/invoice-manual-credit-note-cash-desk-edit.component";
import { CashDeskManualAssociationComponent } from "./components/cash-desk/cash-desk-manual/cash-desk-manual-association/cash-desk-manual-association.component";
import { CashDeskManualAssociationViewDialogComponent } from "./components/dialogs/cash-desk-manual-association-view/cash-desk-manual-association-view-dialog.component";
import { StudyReportDeliveryFilterComponent } from "./components/logistics/study-report-logistics/study-report-delivery/study-report-delivery-filter/study-report-delivery-filter.component";
import { StudyReportDeliverySearchComponent } from "./components/logistics/study-report-logistics/study-report-delivery/study-report-delivery-search/study-report-delivery-search.component";
import { PatientEditControlComponent } from "./components/controls/patient/patient-edit/patient-edit-control.component";
import { PatientEditDialogComponent } from "./components/dialogs/patient-edit/patient-edit-dialog.component";
import { CacheFilterService } from "./services/cache/cache-filter.service";
import { CacheService } from "./services/cache/cache.service";
import { GeographyService } from "./services/geography.service";
import { CellphoneValidator } from "./validators/cellphone.validator";
import { StudyReportWizardFactory } from "./factory/study-report-wizard.factory";
import { MedicalOrderScannViewComponent } from "./components/dialogs/medical-order-scann-view/medical-order-scann-view-dialog.component";
import { MedicalAppointmentReappointmentDialogComponent } from "./components/dialogs/medical-appointment-reappointment/medical-appointment-reappointment-dialog.component";
import { ReferringPhysicianViewComponent } from "./components/controls/referring-physician/referring-physician-view/referring-physician-view-control.component";
import { MedicalServiceReferringPhysicianComponent } from "./components/medical-service/medical-service-referring-physician/medical-service-referring-physician.component";
import { ReferringPhysicianEditControlComponent } from "./components/controls/referring-physician/referring-physician-edit/referring-physician-edit-control.component";
import { ReferringPhysicianDialogComponent } from "./components/dialogs/referring-physician-edit/referring-physician-edit-dialog.component";
import { ValorizationItemAmountEditDialogComponent } from "./components/dialogs/valorization/valorization-item-amount-edit/valorization-item-amount-edit-dialog.component";
import { UserService } from "./services/user.service";
import { AdmissionFilterComponent } from "src/app/components/admission/admission-filter/admission-filter.component";
import { AdmissionSearchComponent } from "./components/admission/admission-search/admission-search.component";
import { AdmissionWizardComponent } from "./components/admission/admission-wizard/admission-wizard.component";
import { ReservationExtraordinaryWizardComponent } from "./components/reservation/reservation-extraordinary-wizard/reservation-extraordinary-wizard.component";
import { ReservationExtraordinaryCalendarComponent } from "./components/reservation/reservation-extraordinary-calendar/reservation-extraordinary-calendar.component";
import { StudyReportDeliveryWizardComponent } from "./components/logistics/study-report-logistics/study-report-delivery/study-report-delivery-wizard/study-report-delivery-wizard.component";
import { StudyReportDeliveryPatientComponent } from "./components/logistics/study-report-logistics/study-report-delivery/study-report-delivery-patient/study-report-delivery-patient.component";
// tslint:disable-next-line:max-line-length
import { StudyReportDeliveryObservationDialogComponent } from "./components/dialogs/study-report-delivery-observation/study-report-delivery-observation-dialog.component";
import { StudyReportDeliveryDetailComponent } from "./components/logistics/study-report-logistics/study-report-delivery/study-report-delivery-detail/study-report-delivery-detail.component";
import { ReservationRescheduleWizardService } from "./services/wizard/reservation/reservation-reschedule.wizard.service";
import { SendOrderLogisticsWizardComponent } from "./components/logistics/order-logistics/send-order-logistics-wizard/send-order-logistics-wizard.component";
import { SendOrderLogisticsDetailComponent } from "./components/logistics/order-logistics/send-order-logistics-detail/send-order-logistics-detail.component";
import { SendOrderLogisticsItemComponent } from "./components/logistics/order-logistics/send-order-logistics-item/send-order-logistics-item.component";
import { OrderBatchLogisticsWizardService } from "./services/wizard/logistic/order-batch-send-wizard.service";
import { SendStudyReportLogisticsFilterComponent } from "./components/logistics/study-report-logistics/send-study-report-logistics-filter/send-study-report-logistics-filter.component";
import { SendStudyReportLogisticsSearchComponent } from "./components/logistics/study-report-logistics/send-study-report-logistics-search/send-study-report-logistics-search.component";
import { SendStudyReportLogisticsDetailComponent } from "./components/logistics/study-report-logistics/send-study-report-logistics-detail/send-study-report-logistics-detail.component";
import { SendStudyReportLogisticsWizardComponent } from "./components/logistics/study-report-logistics/send-study-report-logistics-wizard/send-study-report-logistics-wizard.component";
import { SendStudyReportLogisticsItemComponent } from "./components/logistics/study-report-logistics/send-study-report-logistics-item/send-study-report-logistics-item.component";
import { ReceiveOrderLogisticsFilterComponent } from "./components/logistics/order-logistics/receive-order-logistics-filter/receive-order-logistics-filter.component";
import { ReceiveOrderLogisticsSearchComponent } from "./components/logistics/order-logistics/receive-order-logistics-search/receive-order-logistics-search.component";
import { ReceiveStudyReportLogisticsFilterComponent } from "./components/logistics/study-report-logistics/receive-study-report-logistics-filter/receive-study-report-logistics-filter.component";
import { ReceiveStudyReportLogisticsSearchComponent } from "./components/logistics/study-report-logistics/receive-study-report-logistics-search/receive-study-report-logistics-search.component";
import { ReceiveOrderLogisticsWizardComponent } from "./components/logistics/order-logistics/receive-order-logistics-wizard/receive-order-logistics-wizard.component";
import { ReceiveOrderLogisticsItemComponent } from "./components/logistics/order-logistics/receive-order-logistics-item/receive-order-logistics-item.component";
import { ReceiveStudyReportLogisticsItemComponent } from "./components/logistics/study-report-logistics/receive-study-report-logistics-item/receive-study-report-logistics-item.component";
import { ReceiveStudyReportLogisticsWizardComponent } from "./components/logistics/study-report-logistics/receive-study-report-logistics-wizard/receive-study-report-logistics-wizard.component";
import { ScannerDialogComponent } from "./components/dialogs/scanner/scanner-dialog.component";
import { ScannerFilterComponent } from "./components/scanner/scanner-filter/scanner-filter.component";
import { ScannerSearchComponent } from "./components/scanner/scanner-search/scanner-search.component";
import { ScannerEditComponent } from "./components/scanner/scanner-edit/scanner-edit.component";
import { StudyReportReferringPhysicianComponent } from "./components/study-report/study-report-referring-physician/study-report-referring-physician.component";
import { AssistantHubService } from "./services/assistant-hub";
import { AssistantControlComponent } from "./components/controls/assistant/assistant-control.component";
import { StudyReportTemplateFilterComponent } from "./components/study-report-template/study-report-template-filter/study-report-template-filter.component";
import { StudyReportTemplateSearchComponent } from "./components/study-report-template/study-report-template-search/study-report-template-search.component";
import { StudyReportTemplateEditComponent } from "./components/study-report-template/study-report-template-edit/study-report-template-edit.component";
import { ReservationConfirmationComponent } from "./components/reservation/reservation-confirmation/reservation-confirmation.component";
import { ReservationConfirmationtFilterComponent } from "./components/reservation/reservation-confirmation-filter/reservation-confirmation-filter.component";
import { MedicalAppointmenConfirmationDialogComponent } from "./components/dialogs/medical-appointment-confirmation/medical-appointment-confirmation-dialog.component";
import { AuthorizationService } from "./services/authorization.service";
import { AuthorizationDialogComponent } from "./components/dialogs/authorization/authorization-dialog.component";
import { PracticeRegionPreparationDialogComponent } from "./components/dialogs/practice-region-preparation/practice-region-preparation-dialog.component";
import { ToolPanelControlComponent } from "./components/controls/tool-panel/tool-panel-control.component";
import { ToolMedicalOrderTransitControlComponent } from "./components/controls/tool-panel/tool-medial-order-transit/tool-medical-order-transit-control.component";
import { ToolStudyReportTransitControlComponent } from "./components/controls/tool-panel/tool-study-report-transit/tool-study-report-transit-control.component";
import { NormativeDialogComponent } from "./components/dialogs/normative/normative-dialog.component";
import { APP_ROUTING } from "./app.routes";
import { MedicalServiceConsultationHistoryComponent } from "./components/medical-service/medical-service-consultation-history/medical-service-consultation-history.component";
import { ConsultationHistoryControlComponent } from "./components/controls/consultation-history/consultation-history-control.component";
import { StudyReportConsultationHistoryComponent } from "./components/study-report/study-report-consultation-history/study-report-consultation-history.component";
import { MedicalAppointmentWizardCancelDialogComponent } from "./components/dialogs/medical-appointment-wizard-cancel/medical-appointment-wizard-cancel-dialog.component";
import { MedicalAppointmentInfoControlComponent } from "./components/controls/medical-appointment-info/medical-appointment-info-control.component";
import { StudyReportWizardService } from "src/app/services/wizard/study-report/study-report.wizard.service";
import { ServerTimeService } from "./services/server-time.service";
import { ChangePassComponent } from "./components/change-pass/change-pass.component";
import { LogViewDialogComponent } from "./components/dialogs/log-view/log-view-dialog.component";
import { EditorModule } from "@tinymce/tinymce-angular";
import { TextEditorControlComponent } from "./components/controls/text-editor/text-editor-control";
import { MedicalServiceStudyDeliveryComponent } from "./components/medical-service/medical-service-study-delivery/medical-service-study-delivery.component";
import { DragDropDirectiveDirective } from "./directives/drag-drop-directive.directive";
import { ReportViewerDialogComponent } from "./components/dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component";
import { PatientReservationsDialogComponent } from "./components/dialogs/patient-reservations-dialog/patient-reservations-dialog.component";
import { MedicalAppointmentWaitSearchComponent } from "./components/medical-appointment-wait/medical-appointment-wait-search/medical-appointment-wait-search.component";
import { MedicalAppointmentWaitFilterComponent } from "./components/medical-appointment-wait/medical-appointment-wait-filter/medical-appointment-wait-filter.component";
import { PatientCrmSearchComponent } from "./components/patient-crm/patient-crm-search/patient-crm-search.component";
import { PatientCrmFilterComponent } from "./components/patient-crm/patient-crm-filter/patient-crm-filter.component";
import { PatientCrmWizardComponent } from "./components/patient-crm/patient-crm-wizard/patient-crm-wizard.component";
import { PatientCrmPatientComponent } from "./components/patient-crm/patient-crm-patient/patient-crm-patient.component";
import { PatientCrmCashDeskComponent } from "./components/patient-crm/patient-crm-cash-desk/patient-crm-cash-desk.component";
import { PatientCrmStudyReportComponent } from "./components/patient-crm/patient-crm-study-report/patient-crm-study-report.component";
import { PatientCrmMedicalAppointmentComponent } from "./components/patient-crm/patient-crm-medical-appointment/patient-crm-medical-appointment.component";
import { MedicalAppointmentWaitTraceDialogComponent } from "./components/dialogs/medical-appointment-wait-trace-dialog/medical-appointment-wait-trace-dialog.component";
import { PushNotificationsModule } from "ng-push";
import { DialogCommentPreStudyReportComponent } from "./components/dialogs/dialog-comment-pre-study-report/dialog-comment-pre-study-report.component";
import { DialogClinicalDataComponent } from "./components/dialogs/dialog-clinical-data/dialog-clinical-data.component";
import { DialogTextEditComponent } from "./components/dialogs/dialog-text-edit/dialog-text-edit.component";
import { CallerSearchComponent } from "./components/caller/caller-search/caller-search.component";
import { CallerPatientComponent } from "./components/caller/caller-patient/caller-patient.component";
import { CallerFilterComponent } from "./components/caller/caller-filter/caller-filter.component";
import { OrientationPatientComponent } from "./components/orientation/orientation-patient/orientation-patient.component";
import { OrientationFilterComponent } from "./components/orientation/orientation-filter/orientation-filter.component";
import { OrientationSearchComponent } from "./components/orientation/orientation-search/orientation-search.component";
import { ToolOrientationPatientCallerComponent } from "./components/controls/tool-panel/tool-orientation-patient-caller/tool-orientation-patient-caller.component";
import { BillingOrderFilterComponent } from "./components/billing/billing-order-filter/billing-order-filter.component";
import { BillingOrderSearchComponent } from "./components/billing/billing-order-search/billing-order-search.component";
import { BillingDoOrdenControlDialogComponent } from "./components/dialogs/billing-do-orden-control-dialog/billing-do-orden-control-dialog.component";
import { BillingOrdenControlWizardComponent } from "./components/billing/billing-orden-control-wizard/billing-orden-control-wizard.component";
import { BillingOrdenControlPatientComponent } from "./components/billing/billing-orden-control-patient/billing-orden-control-patient.component";
import { BillingOrdenControlValorizationComponent } from "./components/billing/billing-orden-control-valorization/billing-orden-control-valorization.component";
import { BillingOrdenControlOperationComponent } from "./components/billing/billing-orden-control-operation/billing-orden-control-operation.component";
import { BillingOrdenControlMedicalOrderComponent } from "./components/billing/billing-orden-control-medical-order/billing-orden-control-medical-order.component";
import { BillingOrdenControlClinicHistoryComponent } from "./components/billing/billing-orden-control-clinic-history/billing-orden-control-clinic-history.component";
import { BillingOrdenControlGeneralComponent } from "./components/billing/billing-orden-control-general/billing-orden-control-general.component";
import { BillingMedicalAppointmentProcedureEditDialogComponent } from "./components/dialogs/billing-medical-appointment-procedure-edit-dialog/billing-medical-appointment-procedure-edit-dialog.component";
import { BillingOrdenControlDoComponent } from "./components/billing/billing-orden-control-do/billing-orden-control-do.component";
import { BillingOrdenControlProcedureAffectedDialogComponent } from "./components/dialogs/billing-orden-control-procedure-affected-dialog/billing-orden-control-procedure-affected-dialog.component";
import { StudyReportUnificationDialogComponent } from "./components/dialogs/study-report-unification-dialog/study-report-unification-dialog.component";
import { BillingCloseSearchComponent } from "./components/billing/billing-close-search/billing-close-search.component";
import { BillingCloseFilterComponent } from "./components/billing/billing-close-filter/billing-close-filter.component";
import { NoBillingReasonDialogComponent } from "./components/dialogs/no-billing-reason-dialog/no-billing-reason-dialog.component";
import { BillingCloseTaskDialogComponent } from "./components/dialogs/billing-close-task-dialog/billing-close-task-dialog.component";
import { ToolScheduleTaskComponent } from "./components/controls/tool-panel/tool-schedule-task/tool-schedule-task.component";
import { CashDeskCloseControlSearchComponent } from "./components/cash-desk/cash-desk-close-control/cash-desk-close-control-search/cash-desk-close-control-search.component";
import { CashDeskCloseControlFilterComponent } from "./components/cash-desk/cash-desk-close-control/cash-desk-close-control-filter/cash-desk-close-control-filter.component";
import { ObservationDialogComponent } from "./components/dialogs/observation-dialog/observation-dialog.component";
import { PreBillingFilterComponent } from "./components/billing/pre-billing-filter/pre-billing-filter.component";
import { PreBillingSearchComponent } from "./components/billing/pre-billing-search/pre-billing-search.component";
import { BillingInvoiceEntityEditComponent } from "./components/billing/billing-invoice-entity-edit/billing-invoice-entity-edit.component";
import { BillingInvoiceCreditFilterComponent } from "./components/billing/billing-invoice-credit-filter/billing-invoice-credit-filter.component";
import { BillingInvoiceCreditSearchComponent } from "./components/billing/billing-invoice-credit-search/billing-invoice-credit-search.component";
import { BillingInvoiceEntityCreditEditComponent } from "./components/billing/billing-invoice-entity-credit-edit/billing-invoice-entity-credit-edit.component";
import { BillingOrdenControlScannComponent } from "./components/billing/billing-orden-control-scann/billing-orden-control-scann.component";
import { BillingLogViewDialogComponent } from "./components/dialogs/billing-log-view-dialog/billing-log-view-dialog.component";
import { VideoChatAlertComponent } from "./components/controls/video-chat-alert/video-chat-alert.component";
import { SharedModule } from "./components/shared.module";
import { AppMaterialModule } from "./app.material.module";
import { PagesModule } from "./components/pages.module";
import { BillingReportTypeDialogComponent } from "./components/dialogs/billing-report-type-dialog/billing-report-type-dialog.component";
import { BillingExportTypeDialogComponent } from "./components/dialogs/billing-export-type-dialog/billing-export-type-dialog.component";
import { PasteImageDirective } from "./directives/paste-image.directive";
import { NewPasswordComponent } from "./components/controls/new-password/new-password.component";
import { ChangePassDialogComponent } from "./components/dialogs/change-pass-dialog/change-pass-dialog.component";
import { BillingOrdenControlAttachedFileComponent } from "./components/billing/billing-orden-control-attached-file/billing-orden-control-attached-file.component";
import { PatientCrmAssignmentComponent } from "./components/patient-crm/patient-crm-assignment/patient-crm-assignment.component";
import { PatientCrmAssignmentDialogComponent } from "./components/patient-crm/patient-crm-assignment-dialog/patient-crm-assignment-dialog.component";
import { PatientCrmCoordinatorDialogComponent } from "./components/patient-crm/patient-crm-coordinator-dialog/patient-crm-coordinator-dialog.component";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { PrescriptionDialogComponent } from "./components/dialogs/prescription-dialog/prescription-dialog.component";
import { PrinterFilterComponent } from "./components/printer/printer-filter/printer-filter.component";
import { PrinterSearchComponent } from "./components/printer/printer-search/printer-search.component";
import { PrinterEditComponent } from "./components/printer/printer-edit/printer-edit.component";
import { StudyReportControlFilterComponent } from "./components/study-report/study-report-control-filter/study-report-control-filter.component";
import { StudyReportControlSearchComponent } from "./components/study-report/study-report-control-search/study-report-control-search.component";
import { ReportPhysicianReplacementDialogComponent } from "./components/dialogs/report-physician-replacement-dialog/report-physician-replacement-dialog.component";
import { PreviousStudiesDigitizedShowDialogComponent } from "./components/dialogs/previous-studies-digitized-show-dialog/previous-studies-digitized-show-dialog.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { PatientCrmAssigmentBudgetTimeDialogComponent } from "./components/patient-crm/patient-crm-assigment-budget-time-dialog/patient-crm-assigment-budget-time-dialog.component";
import { ReservationHisRequestDialogComponent } from "./components/dialogs/reservartion-his-request-dialog/reservartion-his-request-dialog.component";
import { ReservationCTWizardComponent } from "./components/reservation/reservation-ct-wizard/reservation-ct-wizard.component";
import { StudyReportLogisticsCommentDialogComponent } from "./components/dialogs/study-report-logistics-comment-dialog/study-report-logistics-comment-dialog.component";
import { StatusPhotographyDialogComponent } from "./components/dialogs/status-photography-dialog/status-photography-dialog.compnent";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { CallerPatientPanelComponent } from "./components/caller/caller-patient/caller-patient-panel/caller-patient-panel.component";
import { PhysiciansDialogComponent } from "./components/dialogs/physicians-dialog/physicians-dialog.component";
import { StudyReportAttachFileComponent } from "./components/study-report/study-report-attach-file/study-report-attach-file.component";
import { StudyReportAttachFileService } from "./services/study-report-attach-file/study-report-attach-file.service";
import { PreConclusionDiagnosticPanelModule } from "./components/controls/pre-conclusion-diagnostic-panel/pre-conclusion-diagnostic-panel.module";
import { PatientChangeAutogestionPassDialogComponent } from "./components/dialogs/patient-change-autogestion-pass/patient-change-autogestion-pass.component";
import { AdmisionReAppointmentComponent } from "./components/admission/admision-re-appointment-search/admision-re-appointment-search.component";
import { AdmisionReAppointmentFilterComponent } from "./components/admission/admision-re-appointment-filter/admision-re-appointment-filter.component";
import { PatientAutocompleteModule } from "./components/autocomplete/patient/patient-autocomplete.module";
import { PipesModule } from "./pipes/pipes.module";
import { ControlsModule } from "./components/controls/controls.module";
import { CashDeskCloseExportDialogComponent } from "./components/cash-desk/cash-desk-close-control/cash-desk-close-export-dialog/cash-desk-close-export-dialog.component";
import { ReceivedLabSampleDialogComponent } from "./components/dialogs/received-lab-sample-dialog/received-lab-sample-dialog.component";
import { StructuredDiagnosisPanelModule } from "./components/controls/structured-diagnosis-panel/structured-diagnosis-panel.module";
import { MedicalAppointmenChangeDateDialogComponent } from "./components/dialogs/medical-appointment-change-date/medical-appointment-change-date-dialog.component";
import { StudyReportKeyImageViewerDialogComponent } from "./components/dialogs/study-report-key-image-viewer-dialog/study-report-key-image-viewer-dialog.component";
import { BillingOrdenControlInvoiceComponent } from "./components/billing/billing-orden-control-invoice/billing-orden-control-invoice.component";
import { ReservationPreWizardComponent } from "./components/reservation/reservation-pre-wizard/reservation-pre-wizard.component";
import { AdmissionReceptionWizardControlComponent } from "./components/controls/admission-reception-wizard-control/admission-reception-wizard-control.component";
import { AdmissionPreReceptionWizardComponent } from "./components/admission/admission-pre-reception-wizard/admission-pre-reception-wizard.component";
import { BillingManualListDialogComponent } from "./components/dialogs/billing-manual-list-dialog/billing-manual-list-dialog.component";
import { ReferringPhysicianInstituteDialogComponent } from "./components/dialogs/referring-physician-institute-dialog/referring-physician-institute-dialog.component";
import { BudgetListDialogComponent } from "./components/dialogs/budget-list-dialog/budget-list-dialog.component";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { TableModule } from "primeng/table";
import { AdmissionIntegratedSearchComponent } from "./components/admission/admission-integrated-search/admission-integrated-search.component";
import { AdmissionIntegratedFilterComponent } from "./components/admission/admission-integrated-filter/admission-integrated-filter.component";
import { PatientMailEditDialogComponent } from "./components/dialogs/patient-mail-edit-dialog/patient-mail-edit-dialog.component";
import { AppointmentWaitDialogComponent } from "./components/dialogs/appointment-wait-dialog/appointment-wait-dialog.component";
import { AdressCPValidator } from "./validators/adress-cp.validator";
import { TxtControlEditorComponent } from "./components/controls/txt-control-editor/txt-control-editor.component";
import { StudyReportEditTxControlComponent } from "./components/controls/study-report/study-report-edit-tx-control/study-report-edit-tx-control.component";
import { OrientationAppointmentListComponent } from "./components/orientation/orientation-patient/orientation-appointment-list/orientation-appointment-list.component";
import { ValorizationItemAddSetInsumoDialogComponent } from "./components/dialogs/valorization/valorization-item-add-set-insumo/valorization-item-add-set-insumo-dialog.component";
import { TestClayerMlComponent } from "./components/test-clayer-ml/test-clayer-ml.component";
import { MedicalOrderProcedureExtractionComponent } from "./components/dialogs/medical-order-procedure-extraction/medical-order-procedure-extraction.component";
import { PreviusStudiesLinksControlComponent } from "./components/controls/previus-studies-links-control/previus-studies-links-control.component";
import { StudyReportDeliverySectorDialogComponent } from "./components/dialogs/study-report-delivery-sector-dialog/study-report-delivery-sector-dialog.component";
import { ClientEditDialogComponent } from "./components/dialogs/client-edit-dialog/client-edit-dialog.component";
import { LaboratoryAppointmentQuestionDialogComponent } from "./components/dialogs/laboratory-appointment-question-dialog/laboratory-appointment-question-dialog.component";
import { BillingInvoiceLogDialogComponent } from "./components/dialogs/billing-invoice-log-dialog/billing-invoice-log-dialog.component";
import { BillingManualInvoiceLogDialogComponent } from "./components/dialogs/billing-manual-invoice-log-dialog/billing-manual-invoice-log-dialog.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    AppComponent,
    ComponentLogin,
    ConsultationHistoryControlComponent,
    StudyReportConsultationHistoryComponent,
    StudyReportFilterComponent,
    MedicalServiceClinicHistoryComponent,
    StudyReportOperationComponent,
    MedicalServiceCareComponent,
    LoginSectorComponent,
    NavMenuComponent,
    MedicalServicePatientComponent,
    SendIndividualOrderLogisticsComponent,
    AutofocusDirective,
    MedicalServiceWizardComponent,
    PhysicianReplacementDialogComponent,
    MedicalAppointmentWizardCancelDialogComponent,
    StudyReportPhysicianSignatureDialogComponent,
    EquipmentReplacementDialogComponent,
    StydyReportWizardComponent,
    MedicalOrderScannComponent,
    MedicalOrderScannZoomDialogComponent,
    MedicalOrderScannDialogComponent,
    ReferringPhysicianDialogComponent,
    StudyReportEditControlComponent,
    StudyReportEditTxControlComponent,
    MedicalServiceConsultationHistoryComponent,
    MedicalServiceOperationComponent,
    InvoicePatientCashDeskEditComponent,
    AdmissionOperationComponent,
    AdmissionMedicalOrderScannComponent,
    CellContainerControlComponent,
    SendOrderLogisticsSearchComponent,
    SendIndividualStudyReportLogisticsComponent,
    HomeComponent,
    ReservationWizardComponent,
    ReservationCTWizardComponent,
    ClinicHistoryControlComponent,
    StudyReportPatientComponent,
    StudyReportClinicHistoryComponent,
    MedicalServiceSearchComponent,
    AdmissionWizardComponent,
    StudyReportSearchComponent,
    QuestionComponent,
    ReminderComponent,
    PatientBottonSheetComponent,
    DialogCancelMedicalAppointmentComponent,
    ChangeEquipmentPhysicianDialogComponent,
    ReceivedLabSampleDialogComponent,
    OtherMedicalAppointmenDialogComponent,
    StudyReportReverserReasonDialogComponent,
    StudyReportDeliverySectorDialogComponent,
    OtherAdmissionMedicalAppointmenDialogComponent,
    MedicalAppointmenObservationDialogComponent,
    AdmissionPatientComponent,
    AdmissionValorizationComponent,
    PatientViewDialogComponent,
    PatientMailEditDialogComponent,
    NormativeDialogComponent,
    PracticeRegionPreparationDialogComponent,
    AuthorizationDialogComponent,
    CashDeskCloseExportDialogComponent,
    MedicalAppointmenConfirmationDialogComponent,
    MedicalAppointmenChangeDateDialogComponent,
    MedicalOrderScannViewComponent,
    MedicalOrderProcedureExtractionComponent,
    StudyReportTemplateDialogComponent,
    StudyReportViewerDialogComponent,
    DialogConfirmtComponent,
    LogViewDialogComponent,
    BillingInvoiceLogDialogComponent,
    BillingManualInvoiceLogDialogComponent,
    LaboratoryAppointmentQuestionDialogComponent,
    ReservationPatientComponent,
    ReservationPracticeComponent,
    ReservationOrderComponent,
    ReservationPriceComponent,
    ReservationQuestionComponent,
    ReservationCalendarComponent,
    ReservationReminderComponent,
    ReservationSearchComponent,
    AdmissionSearchComponent,
    AdmissionIntegratedSearchComponent,
    AdmissionIntegratedFilterComponent,
    AdmissionReceptionSearchComponent,
    AdmisionReAppointmentComponent,
    AdmisionReAppointmentFilterComponent,
    AdmissionMedicalOrderComponent,
    ReservationPatientRequiredComponent,
    PendingCashDeskSearchComponent,
    ReservationFilterComponent,
    PendingCashDeskFilterComponent,
    SendOrderLogisticsFilterComponent,
    ReservationInconsistentFilterComponent,
    AdmissionFilterComponent,
    MedicalServiceFilterComponent,
    AdmissionReceptionFilterComponent,
    AdmissionReceptionWizardComponent,
    AdmissionPreReceptionWizardComponent,
    AdmissionReceptionWizardControlComponent,
    ReservationInconsistentComponent,
    InvoiceManualCashDeskEditComponent,
    AdmissionInvoiceCashDeskComponent,
    MadeCashDeskFilterComponent,
    MadeCashDeskSearchComponent,
    InvoicePatientCreditNoteCashDeskEditComponent,
    InvoicePatientCashDeskViewComponent,
    CashDeskOpenFilterComponent,
    CashDeskOpenSearchComponent,
    CashDeskOpenEditComponent,
    CashDeskManualFilterComponent,
    CashDeskManualSearchComponent,
    InvoiceManualCashDeskViewComponent,
    InvoiceManualCreditNoteCashDeskEditComponent,
    CashDeskManualAssociationComponent,
    CashDeskManualAssociationViewDialogComponent,
    StudyReportDeliveryFilterComponent,
    StudyReportDeliverySearchComponent,
    PatientEditControlComponent,
    PreviusStudiesLinksControlComponent,
    PatientEditDialogComponent,
    PatientChangeAutogestionPassDialogComponent,
    StudyReportDeliveryObservationDialogComponent,
    CellphoneValidator,
    AdressCPValidator,
    MedicalAppointmentReappointmentDialogComponent,
    ReferringPhysicianViewComponent,
    MedicalServiceReferringPhysicianComponent,
    ReferringPhysicianEditControlComponent,
    ValorizationItemAmountEditDialogComponent,
    ValorizationItemAddSetInsumoDialogComponent,
    ReservationExtraordinaryWizardComponent,
    ReservationPreWizardComponent,
    ReservationExtraordinaryCalendarComponent,
    StudyReportDeliveryWizardComponent,
    StudyReportDeliveryDetailComponent,
    StudyReportDeliveryPatientComponent,
    SendOrderLogisticsWizardComponent,
    SendOrderLogisticsDetailComponent,
    SendOrderLogisticsItemComponent,
    SendStudyReportLogisticsFilterComponent,
    SendStudyReportLogisticsSearchComponent,
    SendStudyReportLogisticsDetailComponent,
    SendStudyReportLogisticsWizardComponent,
    SendStudyReportLogisticsItemComponent,
    ReceiveOrderLogisticsFilterComponent,
    ReceiveOrderLogisticsSearchComponent,
    ReceiveStudyReportLogisticsFilterComponent,
    ReceiveStudyReportLogisticsSearchComponent,
    ReceiveOrderLogisticsWizardComponent,
    ReceiveOrderLogisticsItemComponent,
    ReceiveStudyReportLogisticsItemComponent,
    ReceiveStudyReportLogisticsWizardComponent,
    ScannerDialogComponent,
    ScannerFilterComponent,
    ScannerSearchComponent,
    ScannerEditComponent,
    StudyReportReferringPhysicianComponent,
    AssistantControlComponent,
    StudyReportTemplateFilterComponent,
    AdmissionReceptionWizardControlComponent,
    StudyReportTemplateSearchComponent,
    StudyReportTemplateEditComponent,
    TestClayerMlComponent,
    ReservationConfirmationComponent,
    ReservationConfirmationtFilterComponent,
    ToolPanelControlComponent,
    TextEditorControlComponent,
    TxtControlEditorComponent,
    ToolMedicalOrderTransitControlComponent,
    ToolStudyReportTransitControlComponent,
    MedicalAppointmentInfoControlComponent,
    ChangePassComponent,
    MedicalServiceStudyDeliveryComponent,
    DragDropDirectiveDirective,
    ReportViewerDialogComponent,
    PatientReservationsDialogComponent,
    MedicalAppointmentWaitSearchComponent,
    MedicalAppointmentWaitFilterComponent,
    PatientCrmSearchComponent,
    PatientCrmFilterComponent,
    PatientCrmWizardComponent,
    PatientCrmPatientComponent,
    PatientCrmCashDeskComponent,
    PatientCrmStudyReportComponent,
    PatientCrmMedicalAppointmentComponent,
    MedicalAppointmentWaitTraceDialogComponent,
    DialogCommentPreStudyReportComponent,
    DialogClinicalDataComponent,
    DialogTextEditComponent,
    CallerSearchComponent,
    CallerPatientComponent,
    CallerFilterComponent,
    OrientationPatientComponent,
    OrientationAppointmentListComponent,
    OrientationFilterComponent,
    OrientationSearchComponent,
    ToolOrientationPatientCallerComponent,
    BillingOrderFilterComponent,
    BillingOrderSearchComponent,
    BillingDoOrdenControlDialogComponent,
    BillingOrdenControlWizardComponent,
    BillingOrdenControlPatientComponent,
    BillingOrdenControlValorizationComponent,
    BillingOrdenControlOperationComponent,
    BillingOrdenControlInvoiceComponent,
    BillingOrdenControlMedicalOrderComponent,
    BillingOrdenControlClinicHistoryComponent,
    BillingOrdenControlAttachedFileComponent,
    BillingOrdenControlGeneralComponent,
    BillingMedicalAppointmentProcedureEditDialogComponent,
    BillingOrdenControlDoComponent,
    BillingOrdenControlProcedureAffectedDialogComponent,
    StudyReportUnificationDialogComponent,
    BillingCloseSearchComponent,
    BillingCloseFilterComponent,
    NoBillingReasonDialogComponent,
    BillingCloseTaskDialogComponent,
    ToolScheduleTaskComponent,
    CashDeskCloseControlSearchComponent,
    CashDeskCloseControlFilterComponent,
    ObservationDialogComponent,
    StudyReportLogisticsCommentDialogComponent,
    StudyReportKeyImageViewerDialogComponent,
    StatusPhotographyDialogComponent,
    CallerPatientPanelComponent,
    PreBillingFilterComponent,
    PreBillingSearchComponent,
    BillingInvoiceEntityEditComponent,
    BillingInvoiceCreditFilterComponent,
    BillingInvoiceCreditSearchComponent,
    BillingInvoiceEntityCreditEditComponent,
    BillingOrdenControlScannComponent,
    BillingManualListDialogComponent,
    BillingLogViewDialogComponent,
    PhysiciansDialogComponent,
    ClientEditDialogComponent,
    VideoChatAlertComponent,
    BillingReportTypeDialogComponent,
    BillingExportTypeDialogComponent,
    PasteImageDirective,
    NewPasswordComponent,
    BudgetListDialogComponent,
    AppointmentWaitDialogComponent,
    ChangePassDialogComponent,
    BillingOrdenControlAttachedFileComponent,
    PatientCrmAssignmentComponent,
    PatientCrmAssignmentDialogComponent,
    PatientCrmCoordinatorDialogComponent,
    PrescriptionDialogComponent,
    PrinterFilterComponent,
    PrinterSearchComponent,
    PrinterEditComponent,
    StudyReportControlFilterComponent,
    StudyReportControlSearchComponent,
    ReportPhysicianReplacementDialogComponent,
    ReferringPhysicianInstituteDialogComponent,
    ReservationHisRequestDialogComponent,
    PreviousStudiesDigitizedShowDialogComponent,
    SettingsComponent,
    PatientCrmAssigmentBudgetTimeDialogComponent,
    StudyReportAttachFileComponent,
  ],
  imports: [
    AppMaterialModule,
    TableModule,
    AngularFontAwesomeModule,
    PreConclusionDiagnosticPanelModule,
    StructuredDiagnosisPanelModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    AngularEditorModule,
    QRCodeModule,
    BrowserModule,
    HttpClientModule,
    ControlsModule,
    AngularResizedEventModule,
    PipesModule,
    PerfectScrollbarModule,
    PushNotificationsModule,
    PagesModule,
    SharedModule,
    PatientAutocompleteModule,
    DeviceDetectorModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    HotkeyModule.forRoot(),
    HotkeyModule,
    APP_ROUTING,
  ],
  providers: [
    LoginWizardService,
    QRCodeService,
    AssistantHubService,
    DataService,
    AuthService,
    Base64ToBlobService,
    AuthGuard,
    PatientService,
    EntityService,
    ReservationRegularWizardService,
    StudyReportService,
    StudyReportAttachFileService,
    ValorizationService,
    PracticeService,
    NotificationToastService,
    ConfirmDialogService,
    ServiceService,
    FilterService,
    PhysicianService,
    EquipmentService,
    AdmissionService,
    ReportService,
    FilterRecordService,
    ReservationService,
    MedicalOrderService,
    InvoicePatientCashDeskService,
    MedicalServiceService,
    MedicalServiceWizardService,
    LogisticsService,
    PdfService,
    CashDeskService,
    InvoicePointService,
    MenuService,
    ClientService,
    CacheFilterService,
    CacheService,
    GeographyService,
    UserService,
    StudyReportWizardFactory,
    AuthorizationService,
    ReservationRescheduleWizardService,
    StudyReportWizardService,
    ServerTimeService,
    OrderBatchLogisticsWizardService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: "BASE_URL", useFactory: getBaseUrl },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    PatientBottonSheetComponent,
    PreviousStudiesDigitizedShowDialogComponent,
    DialogConfirmtComponent,
    BillingInvoiceLogDialogComponent,
    BillingManualInvoiceLogDialogComponent,
    LogViewDialogComponent,
    LaboratoryAppointmentQuestionDialogComponent,
    EquipmentReplacementDialogComponent,
    MedicalAppointmenObservationDialogComponent,
    MedicalAppointmentWaitTraceDialogComponent,
    PatientViewDialogComponent,
    PatientMailEditDialogComponent,
    NormativeDialogComponent,
    PracticeRegionPreparationDialogComponent,
    AuthorizationDialogComponent,
    CashDeskCloseExportDialogComponent,
    MedicalAppointmenConfirmationDialogComponent,
    MedicalAppointmenChangeDateDialogComponent,
    MedicalOrderScannViewComponent,
    MedicalOrderProcedureExtractionComponent,
    ReportViewerDialogComponent,
    StudyReportTemplateDialogComponent,
    StudyReportViewerDialogComponent,
    CashDeskManualAssociationViewDialogComponent,
    ChangeEquipmentPhysicianDialogComponent,
    ReceivedLabSampleDialogComponent,
    OtherMedicalAppointmenDialogComponent,
    PatientReservationsDialogComponent,
    PhysicianReplacementDialogComponent,
    MedicalAppointmentWizardCancelDialogComponent,
    StudyReportReverserReasonDialogComponent,
    StudyReportDeliverySectorDialogComponent,
    StudyReportPhysicianSignatureDialogComponent,
    OtherAdmissionMedicalAppointmenDialogComponent,
    AdmissionReceptionFilterComponent,
    ScannerDialogComponent,
    MedicalOrderScannDialogComponent,
    ReferringPhysicianDialogComponent,
    MedicalOrderScannZoomDialogComponent,
    DialogCancelMedicalAppointmentComponent,
    DialogTextEditComponent,
    DialogCommentPreStudyReportComponent,
    DialogClinicalDataComponent,
    PatientEditDialogComponent,
    PatientChangeAutogestionPassDialogComponent,
    StudyReportUnificationDialogComponent,
    StudyReportDeliveryObservationDialogComponent,
    ValorizationItemAmountEditDialogComponent,
    ValorizationItemAddSetInsumoDialogComponent,
    ToolMedicalOrderTransitControlComponent,
    ToolStudyReportTransitControlComponent,
    ToolOrientationPatientCallerComponent,
    BillingDoOrdenControlDialogComponent,
    BillingMedicalAppointmentProcedureEditDialogComponent,
    BillingOrdenControlProcedureAffectedDialogComponent,
    NoBillingReasonDialogComponent,
    BillingCloseTaskDialogComponent,
    StatusPhotographyDialogComponent,
    ToolScheduleTaskComponent,
    ObservationDialogComponent,
    StudyReportLogisticsCommentDialogComponent,
    StudyReportKeyImageViewerDialogComponent,
    BillingLogViewDialogComponent,
    ClientEditDialogComponent,
    BillingManualListDialogComponent,
    PhysiciansDialogComponent,
    BillingReportTypeDialogComponent,
    ReferringPhysicianInstituteDialogComponent,
    BillingExportTypeDialogComponent,
    ReportPhysicianReplacementDialogComponent,
    ReservationHisRequestDialogComponent,
    ChangePassDialogComponent,
    PatientCrmAssignmentDialogComponent,
    PatientCrmCoordinatorDialogComponent,
    PatientCrmAssigmentBudgetTimeDialogComponent,
    PrescriptionDialogComponent,
    AppointmentWaitDialogComponent,
    MedicalAppointmentReappointmentDialogComponent,
    BudgetListDialogComponent,
  ],
  exports: [PatientBottonSheetComponent],
})
export class AppModule {}

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}
